import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import ls from "local-storage";
import styled from "styled-components";

import { Button } from "../ui-kit/styled-templates";
import PartnersPanel from "../partners/PartnersPanel";
import PartnersListTool from "../partners/tools/PartnersListTool";
import { useNavigate } from "react-router-dom";
import TripsPanel from "../trips/TripsPanel";

const PartnersPage = () => {
    const { t, i18n } = useTranslation();
    const [bigUrl, setBigUrl] = useState(undefined);
    const navigate = useNavigate();
    let isRu = i18n.language == "ru";

    return (
        <OuterWrapper className={"about_page"}>
            <Wrapper>
                <TopPlaceholder>
                    {/*<SupTopPlaceholder>*/}
                    {/*    <BackLink href={"/"}>{t("52je87244bb")}</BackLink>*/}
                    {/*</SupTopPlaceholder>*/}
                    <Heading>{t("lr602uxq31o")}</Heading>
                </TopPlaceholder>

                <ContentPlaceholder>
                    <Left>
                        <MyP>{t("p0mwhwqjblp")}</MyP>

                        <PartnersPanel
                            mode={'view'}
                        />

                        {/*<TripsPanel*/}
                        {/*    mode={'view'}*/}
                        {/*    type={'partners'}*/}
                        {/*    isInternational={true}*/}
                        {/*/>*/}



                        {/*<PartnersListTool*/}
                        {/*    is50={false}*/}
                        {/*/>*/}

                        <Heading22 style={{marginTop: 70, marginBottom: 50}} >
                            {isRu ? 'Партнерские инициативы' : 'Partnership initiatives'}
                        </Heading22>

                        <PartnersListTool
                            is50={true}
                            isGreen={true}
                            partners={[
                                {
                                    name: isRu ? 'Военно-патриотический туризм' : 'Military-patriotic tourism',
                                    image: 'https://welcome-belarus.ru/wp-content/uploads/2020/02/%D0%92%D0%BE%D0%B5%D0%BD%D0%BD%D0%BE-%D0%BF%D0%B0%D1%82%D1%80%D0%B8%D0%BE%D1%82%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%B8%D0%B5-%D1%82%D1%83%D1%80%D1%8B-%D0%B2-%D0%91%D0%B5%D0%BB%D0%B0%D1%80%D1%83%D1%81%D1%8C.jpeg',
                                    url: '/patriot'
                                },
                                {
                                    name: isRu ? 'Промышленный туризм' : 'Industrial tourism',
                                    image: 'https://senatinform.ru/upload/resize_cache/sprint.editor/de8/798_448_1/de8a04f5dadf1bae5ff332cfb8cfbac5.jpg',
                                    url: '/industrial'
                                }
                            ]}
                            onItemClick={x => {
                                navigate(x.url);
                            }}
                        />

                    </Left>

                </ContentPlaceholder>
            </Wrapper>

            {bigUrl == undefined ? null : (
                <GlobalWarningPlaceholder>
                    <WhiteBox>
                        <img src={bigUrl} style={{ width: "100%" }} />
                        <WarningButtonPlaceholder>
                            <Button
                                onClick={() => {
                                    ls("first-visit-warning", false);
                                    setBigUrl(undefined);
                                }}
                            >
                                {t("n9c22f9eo6")}
                            </Button>
                        </WarningButtonPlaceholder>
                    </WhiteBox>
                </GlobalWarningPlaceholder>
            )}


        </OuterWrapper>
    );
};

const TopImg = styled.img`
  display: block;
  width: 100%;
  @media (max-width: 820px) {
    display: none;
  }
`;

const GlobalWarningPlaceholder = styled.div`
  position: fixed;
  z-index: 100;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const WhiteBox = styled.div`
  padding: 20px;
  border-radius: 8px;
  text-align: justify;
  background: white;
  width: 620px;
  box-sizing: border-box;
  @media (max-width: 620px) {
    width: calc(100vw - 40px);
    padding: 10px;
  }
`;

const WarningButtonPlaceholder = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LoImg = styled.div`
  width: 240px;
  height: 240px;
  box-sizing: border-box;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${(props) => props.src});
  margin: 10px;
  cursor: pointer;
`;

const Ul = styled.ul`
  box-sizing: border-box;
  padding-left: 15px;
  margin-bottom: 25px;
`;

const Li = styled.li`
  margin-bottom: 10px;
  box-sizing: border-box;
`;

const Heading2 = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 27px;
  color: #212121;
`;

const Heading22 = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 50px;
  color: #212121;
  @media(max-width: 700px){
    font-size: 24px;
    line-height: 42px;
  }
`;


const BLabel = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #212529;
`;

const DownImg = styled.img`
  height: 24px;
  cursor: pointer;
`;

const FileItemHeading = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #212529;
`;

const FileItemSubHeading = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #aaaaaa;
`;

const RightContentPlaceholder = styled.div``;

const MyP = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  color: #212529;
  margin-bottom: 25px;
  font-family: "Noto Sans", sans-serif;
`;

const FileItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  cursor: pointer;
`;

const FileItemContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const FileItemLeft = styled.div`
  flex: 1;
`;

const FileItemRight = styled.div``;

const FileImg = styled.img`
  height: 40px;
  margin-right: 8px;
`;

const RightHeading = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 27px;
  font-family: "Noto Sans", sans-serif;
  margin-bottom: 20px;
`;

const Left = styled.div`
  flex: 1;
  @media (max-width: 800px) {
    margin-left: 0px;
    padding: 5px;
  }
`;

const Right = styled.div`
  width: 380px;
  margin-left: 40px;
  @media (max-width: 800px) {
    margin-left: 0px;
    padding: 5px;
  }
`;

const RightBox = styled.div`
  background: #f4f9fc;
  border-radius: 12px;
  box-sizing: border-box;
  padding: 32px;
  margin-bottom: 32px;
  @media (max-width: 800px) {
    padding: 20px;
  }
`;

const ContentPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  @media (max-width: 800px) {
    display: block;
  }
`;

const BackLink = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.grey};
  cursor: pointer;
`;

const OuterWrapper = styled.div`
  width: 100%;
  background: white;
  padding-top: 30px;
  box-sizing: border-box;
  padding-bottom: 40px;
`;

const Wrapper = styled.div`
  text-align: left;
  box-sizing: border-box;
  width: 1400px;
  margin: 0 auto;
  padding: 15px;
  @media (max-width: 1400px) {
    width: 100%;
  }
`;

const Heading = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 56px;
  line-height: 72px;
  margin-bottom: 40px;
  @media (max-width: 820px) {
    font-size: 24px;
    line-height: 32px;
    padding-left: 5px;
  }
`;

const SupTopPlaceholder = styled.div`
  margin-bottom: 20px;
`;

const TopPlaceholder = styled.div``;

export default PartnersPage;
